import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { useNeueVersion } from '../../hooks/useNeueVersion';
import { ladeSeiteNeu } from '../../lib/neueVersion';

/**
 * Nach einem Deploy läuft ein offener Tab mit dem alten Bundle weiter. Der Hinweis
 * sagt das, lädt aber nicht selbst neu — in offenen Formularen ginge sonst Eingabe
 * verloren. Wegklicken lässt er sich nicht: Wer weiterarbeitet, soll wissen, dass er
 * auf dem alten Stand ist.
 *
 * Er liegt über Dialogen (z-50), damit er auch mitten in einem Assistenten sichtbar
 * wird, und auf schmalen Bildschirmen über dem Melde-Knopf unten rechts.
 */
export function NeueVersionHinweis() {
  const neu = useNeueVersion();
  if (!neu) return null;
  return (
    <div
      role="status"
      className="pointer-events-auto fixed inset-x-4 bottom-20 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-md border border-border/70 bg-background px-4 py-3 text-sm text-foreground shadow-surface motion-safe:animate-fade-up md:bottom-5"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="font-medium">Neue Version verfügbar</p>
        <p className="text-xs text-muted-foreground">
          Speichere offene Eingaben und lade die Seite dann neu.
        </p>
      </div>
      <Button size="sm" onClick={ladeSeiteNeu}>
        Neu laden
      </Button>
    </div>
  );
}
